/* lua.js generated code 0.3.0 */

var MenuItem = xClass("MenuItem", function (csbfile) {
    // WARN: maybe multi result
    return cc.CSLoader.createNode(csbfile)
})
MenuItem.prototype.ctor = function (csbfile, label) {
    var self = this
    self.init(label)
}
MenuItem.prototype.init = function (label) {
    var self = this
    self.getChildByName("label").setString(label)
    self.status = false
}
MenuItem.prototype.addTo = function (parent) {
    var self = this
    parent.addChild(self)
    return self
}
MenuItem.prototype.move = function (x, y) {
    var self = this
    self.move(x, y)
    return self
}
MenuItem.prototype.isSelected = function () {
    var self = this
    return self.status
}
MenuItem.prototype.select = function (status) {
    var self = this
    self.status = status
    self.getChildByName("selectedBg").setVisible(status)
    self.getChildByName("normalBg").setVisible(!status)
    return self
}
MenuItem.prototype.onClicked = function (callback) {
    var self = this
    var ctx = self
    var bg = self.getChildByName("selectedBg")
    function onTouchesBegan(touch, event) {
        var tp = touch.getLocation()
        var position = self.convertToWorldSpace(cc.p(bg.getPosition()))
        var s = bg.getContentSize()
        var ap = bg.getAnchorPoint()
        var touchRect = cc.rect(position.x - ap.x * s.width, position.y - s.height * ap.y, s.width, s.height)
        var b = cc.rectContainsPoint(touchRect, tp)
        return b
    }
    function onTouchesEnd(touch, event) {
        callback(touch, event)
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(onTouchesBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(onTouchesEnd, cc.Handler.EVENT_TOUCH_ENDED)
    var eventDispatcher = bg.getEventDispatcher()
    eventDispatcher.addEventListenerWithSceneGraphPriority(listener, bg)
    return self
}
module.exports = MenuItem
